import SortableItem from './container';

export default SortableItem;
